import { HttpErrorResponse } from '@angular/common/http';

export abstract class HttpErrorGenericHandler {
  abstract handleError(error: HttpErrorResponse): boolean;
}
